import React, { Component } from 'react';
import { connect } from 'react-redux';

import Container from 'app/common/narrow-container';
import i18n from 'app/common/i18n';

import ProfileTab from './tabs/profile';
import ChangePassword from './tabs/change-password';

import { setTitle } from 'app/layout/redux';
import { update, UPDATE_FAIL } from 'app/redux/modules/auth';

import { toastr } from 'app/common/toastr';
import ResendEmailVerification from './resend-email-verification';

@connect(({ auth: { user } }) => ({ user }), {
  setTitle,
  update
})
@i18n
class Profile extends Component {
  componentDidMount() {
    this.props.setTitle(this.props.i18n('My Account'));
  }

  componentWillUnmount() {
    this.props.setTitle();
  }

  handleRequestUpdate = (user) => {
    return this.props.update(user).then((action) => {
      if (action.type === UPDATE_FAIL) {
        const { error: { response } = {} } = action || {};

        toastr.error(
          this.props.i18n('Edit account'),
          this.props.i18n(response.message)
        );
        throw this.props.i18n(response.message);
      } else {
        toastr.success(
          this.props.i18n('Edit account'),
          this.props.i18n('Your changes has been saved')
        );
      }
      return action;
    });
  };

  render() {
    const { user } = this.props;

    return user ? (
      <Container className="settings">
        <ProfileTab user={user} onRequestUpdate={this.handleRequestUpdate} />
        {user?.get('emailVerified') ? null : (
          <ResendEmailVerification props={this.props} />
        )}
        <ChangePassword />
      </Container>
    ) : null;
  }
}

export default Profile;
